export const Define = {
	browser: {
		user_agent       : 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.149 Safari/537.36',
		accept           : {
			page  : 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
			image : 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
			upload: 'text/html, */*; q=0.01',
		},
		accept_language  : 'ja,en;q=0.9',
		width            : 800,
		height           : 600,
		dialog_close_wait: 0.2,
		session_path     : 'session/',
		screenshot_path  : 'screenshot/',
		cookie_path      : 'cookie/',
		timeout_second   : 10,
	},

	shop: {
		select_expire_day: 7,
		chat_url         : 'https://meet.jit.si/%s',
	},

	day_of_week: ['日', '月', '火', '水', '木', '金', '土'],
}
